import * as React from "react";
import { useToggle } from "react-use";
import { UserModal } from "./userModal";

export const UsersCreateButton: React.FC = () => {
  const [isOpen, toggleIsOpen] = useToggle(false);

  return (
    <>
      {isOpen && <UserModal isOpen={isOpen} setIsOpen={toggleIsOpen} />}
      <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
        <button
          onClick={toggleIsOpen}
          type="button"
          className="block rounded-md bg-primary px-3 py-2 text-center text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Add user
        </button>
      </div>
    </>
  );
};
